import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { StyledField } from "../../../common/components/FilterDashboard/styles";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { StyledButton } from "../../../common/components/Button/styles";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { InputLabel } from "@mui/material";
import FilterDashboard from "../../../common/components/FilterDashboard";
import {
  getCases,
  getCasesByDentistUserId,
  getCasesByFilter,
} from "../../../api/caseApi";
import { Tooltip } from "@mui/material";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import { blue, brown, green, orange, purple, teal } from "@mui/material/colors";
import ConfirmationDialog from "../../../common/components/Dialog";
import { useForm } from "react-hook-form";
import { caseFiltersSchema } from "../schema/caseFiltersSchema";
import { Controller } from "react-hook-form";
const CasesTable = ({ theme, user }) => {
  const navigate = useNavigate();
  const [appearStatusLabel, setAppearStatusLabel] = useState(true);
  const [appearShowTerminated, setAppearShowTerminated] = useState(true);

  const [pageSize, setPageSize] = useState(25);
  const [patientList, setPatientList] = useState([]);
  const {
    register,
    watch,
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(caseFiltersSchema),
  });
  const status = watch("status");
  const showTerminatedCases = watch("showTerminatedCases");

  const fetchPatients = async () => {
    let response;
    if (user.roles.includes("Operations")) {
      response = await getCases();
    } else {
      response = await getCasesByDentistUserId(user.id);
    }
    console.log(response);
    const allCases = response.map((mycase) => {
      return {
        ...mycase,
        patientName: mycase.patient.firstName + " " + mycase.patient.lastName,
        patientDOB: mycase.patient.dateOfBirth,
        dentistName: `${
          mycase.dentist == null
            ? "No dentist"
            : mycase.dentist.user.firstName + " " + mycase.dentist.user.lastName
        }`,
        dentistDOB: `${
          mycase.dentist == null ? "null" : mycase.dentist.dateOfBirth
        }`,
        dentalClinicName: `${
          mycase.dentist == null ? "" : mycase.dentist.dentalClinic.name
        }`,
        isAiPaid: mycase.createdBy = "alinagpt" ? mycase.caseProgressions.at(-1).isPaid : null
        // dueDate:
        //   mycase.status === "For shipment"
        //     ? mycase.caseProgressions.at(-1).fabricationDate
        //     : mycase.status === "Case complete" ||
        //       mycase.status === "For next set"
        //     ? mycase.caseProgressions.at(-1).shipmentDate
        //     : mycase.caseProgressions.at(-1).dueDate,
      };
    });
    setPatientList(allCases);
  };

  useEffect(() => {
    const defaultValues = {};
    console.log(user.firstname);
    console.log(user.lastname);
    defaultValues.showTerminatedCases = false;
    defaultValues.userFullName = user.firstname + " " + user.lastname;
    defaultValues.userRole = user.roles.includes("Operations")
      ? "Operations"
      : user.roles.includes("Dentist")
      ? "Dentist"
      : "";

    reset({ ...defaultValues });
    fetchPatients();
  }, []);

  //Patient Details
  const handleRowClick = (params) => {
    navigate(`/cases/${params.row.id}`, { state: params.row });
  };

  const handleNewPatientClick = () => {
    navigate(`add-new-patient`);
  };

  const handlePaymentClick = () => {
    navigate(`payment-summary`);
  };

  const handleSubmitFilter = async (model) => {
    const response = await getCasesByFilter(model);

    const allCases = response.map((mycase) => {
      return {
        ...mycase,
        patientName: mycase.patient.firstName + " " + mycase.patient.lastName,
        patientDOB: mycase.patient.dateOfBirth,
        dentistName: `${
          mycase.dentist == null
            ? "No dentist"
            : mycase.dentist.user.firstName + " " + mycase.dentist.user.lastName
        }`,
        dentistDOB: `${
          mycase.dentist == null ? "null" : mycase.dentist.dateOfBirth
        }`,
        dentalClinicName: `${
          mycase.dentist == null ? "" : mycase.dentist.dentalClinic.name
        }`,
        // dueDate:
        //   mycase.status === "For shipment"
        //     ? hasCaseProgressions &&
        //       mycase.caseProgressions.at(-1).fabricationDate
        //     : mycase.status === "Case complete" ||
        //       mycase.status === "For next set"
        //     ? hasCaseProgressions && mycase.caseProgressions.at(-1).shipmentDate
        //     : hasCaseProgressions && mycase.caseProgressions.at(-1).dueDate,
      };
    });
    console.log(allCases);

    setPatientList(allCases);
  };

  const columns = [
    {
      field: "caseNo",
      headerName: "Case No.",
      headerClassName: "column-header",
      flex: 1,
    },
    {
      field: "patientName",
      headerName: "Patient",
      headerClassName: "column-header",
      flex: 1.6,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "dentistName",
      headerName: "Dentist",
      headerClassName: "column-header",
      flex: 1.6,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "dentalClinicName",
      headerName: "Dental Clinic",
      headerClassName: "column-header",
      flex: 1.6,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "column-header",
      cellClassName: (params) => {
        const status = params.value.toLowerCase();
        const isAiPaid = params.row.isAiPaid; // Access AiPaid status
        const isAiCase = params.row.createdBy == "alinagpt";
        let className = "case-status ";

        if (status.includes("consult")) {
          className = className + (isAiCase && !isAiPaid ? "consult-ai-not-paid" : "consult-status");
        } else if (status.includes("scan")) {
          className = className + "scan-status";
        } else if (status.includes("payment")) {
          className = className + "payment-status";
        } else if (status.includes("set")) {
          className = className + "set-status";
        } else if (status.includes("design")) {
          className = className + "design-status";
        } else if (status.includes("shipment")) {
          className = className + "shipment-status";
        }

        return className;
      },
      flex: 1.6,
    },
    {
      field: "dueDate",
      headerClassName: "column-header",
      headerName: "Due Date",
      flex: 1.4,
      valueFormatter: (params) =>
        params?.value !== null ? normalizeDateTime(params?.value) : "",
    },
  ];

  return (
    <Box
      sx={{
        "& .column-header": {
          backgroundColor: "#F0F0F0",
        },
        "& .case-status": {
          fontWeight: 600,
        },
        "& .consult-status": {
          color: teal[400],
        },
        "& .consult-ai-not-paid": {
          color: "#FFD700", // dark yellow
        },
        "& .scan-status": {
          color: orange[400],
        },
        "& .payment-status": {
          color: green[400],
        },
        "& .set-status": {
          color: purple[400],
        },
        "& .design-status": {
          color: blue[400],
        },
        "& .shipment-status": {
          color: brown[400],
        },
      }}
    >
      <Box
        sx={{
          paddingBottom: 2,
        }}
      >
        <StyledButton
          style={{ marginRight: "10px" }}
          theme="green"
          onClick={handleNewPatientClick}
        >
          New Patient
        </StyledButton>
        <StyledButton theme="green" onClick={handlePaymentClick}>
          Payment Summary
        </StyledButton>
      </Box>
      <FilterDashboard>
        Case Filters
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
          <FormControl>
            <InputLabel
              sx={{
                transform: !status
                  ? "translate(14px, 14px) scale(1)"
                  : "translate(14px, -6px) scale(0.75)",

                "&.Mui-focused": {
                  transform: "translate(14px, -6px) scale(0.75)",
                },
              }}
              style={{
                margin: "-5px",
                paddingLeft: "20px",
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "14px",
                color: "#161616",
              }}
            >
              Status
            </InputLabel>
            <Select
              onFocus={() => setAppearStatusLabel(false)}
              onClose={() => {
                setAppearStatusLabel(true);
              }}
              style={{
                height: "35px",
                width: "150px",
                borderRadius: "20px",
                backgroundColor: "white",
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "14px",
                marginLeft: "10px",
                marginTop: "3px",
                marginBottom: "3px",
              }}
              {...register("status")}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"For online consultation"}>
                For online consultation
              </MenuItem>
              <MenuItem value={"For F2F consultation"}>
                For F2F consultation
              </MenuItem>
              <MenuItem value={"For scanning"}>For scanning</MenuItem>
              <MenuItem value={"Design in progress"}>
                Design in progress
              </MenuItem>
              <MenuItem value={"For design approval"}>
                For design approval
              </MenuItem>
              <MenuItem value={"Design approved"}>Design approved</MenuItem>
              <MenuItem value={"For fabrication"}>For fabrication</MenuItem>
              <MenuItem value={"For shipment"}>For shipment</MenuItem>
              <MenuItem value={"For payment"}>For payment</MenuItem>
              <MenuItem value={"Case complete"}>Case complete</MenuItem>
            </Select>
          </FormControl>

          <FormControl>
            <InputLabel
              sx={{
                transform:
                  showTerminatedCases == null
                    ? "translate(14px, 14px) scale(1)"
                    : "translate(14px, -6px) scale(0.75)",

                "&.Mui-focused": {
                  transform: "translate(14px, -6px) scale(0.75)",
                },
              }}
              style={{
                margin: "-5px",
                paddingLeft: "20px",
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "14px",
                color: "#161616",
              }}
            >
              Show Terminated Cases
            </InputLabel>
            <Select
              defaultValue={false}
              style={{
                height: "35px",
                width: "210px",
                borderRadius: "20px",
                backgroundColor: "white",
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "14px",
                marginLeft: "10px",
                marginTop: "3px",
                marginBottom: "3px",
              }}
              {...register("showTerminatedCases")}
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </Select>
          </FormControl>

          <StyledField
            placeholder="Case No."
            {...register("caseNo")}
            sx={{
              input: {
                color: "#161616",
                "&::placeholder": {
                  opacity: 1,
                },
              },
            }}
          />

          <StyledField
            sx={{
              input: {
                color: "#161616",
                "&::placeholder": {
                  opacity: 1,
                },
              },
            }}
            placeholder="Patient Name"
            {...register("patientName")}
          />
          {user.roles.includes("Operations") && (
            <>
              <StyledField
                sx={{
                  input: {
                    color: "#161616",
                    "&::placeholder": {
                      opacity: 1,
                    },
                  },
                }}
                placeholder="Dentist Name"
                {...register("dentistName")}
              />
              <StyledField
                sx={{
                  input: {
                    color: "#161616",
                    "&::placeholder": {
                      opacity: 1,
                    },
                  },
                }}
                placeholder="Dental Clinic Name"
                {...register("dentalClinicName")}
              />
            </>
          )}

          <StyledButton
            style={{
              marginLeft: "10px",
              marginTop: "3px",
              marginBottom: "3px",
            }}
            type="submit"
            theme="green"
            disabled={isSubmitting}
          >
            Search
          </StyledButton>
        </form>
      </FilterDashboard>

      <StyledDataGrid
        autoHeight
        onRowClick={handleRowClick}
        rows={patientList}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[25, 50, 100]}
        pagination
      />
    </Box>
  );
};

export default CasesTable;
